import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { DefaultLayoutComponent } from './layout/default-layout/default-layout.component';
import { HomeComponent } from './components/home/home.component';
import { UserInfoComponent } from './components/core/user-info/user-info.component';
import { AppInfoComponent } from './components/core/app-info/app-info.component';
import { LoginFailedComponent } from './components/core/login-failed/login-failed.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AuthGuard } from './auth/auth-guard';
import { ComplaintsComponent } from './components/complaints/complaints.component';
import { PaymentsComponent } from './components/payments/components/payments/payments.component';
import { PayOnlineComponent } from './components/payments/components/pay-online/pay-online.component';
import { PayOnlineCancelComponent } from './components/payments/components/pay-online/cancel/pay-online-cancel.component';
import { PayOnlineFailureComponent } from './components/payments/components/pay-online/failure/pay-online-failure.component';
import { PayOnlineDuplicateComponent } from './components/payments/components/pay-online/duplicate/pay-online-duplicate.component';
import { PayOnlineSuccessComponent } from './components/payments/components/pay-online/success/pay-online-success.component';
import { AtpComponent } from './components/atp/atp.component';
import { AtpApplicationListComponent } from './components/atp/atp-application-list/atp-application-list.component';
import { FirmFeatureGuard } from './auth/firm-feature.guard';
import { IndividualFeatureGuard } from './auth/individual-feature.guard';
import { FirmManagementComponent } from './components/firms/firm-management/firm-management.component';
import { FirmApplicationListComponent } from './components/firms/firm-application-list/firm-application-list.component';
import { FirmEditComponent } from './components/firms/firm-edit/firm-edit.component';
import { IndividualListComponent } from './components/individuals/individual-list/individual-list.component';
import { IndividualApplicationListComponent } from './components/individuals/individual-application-list/individual-application-list.component';
import { IndividualEditComponent } from './components/individuals/individual-edit/individual-edit.component';
import { AccountLinkApprovalComponent } from './components/common/account-link-approval/account-link-approval.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },      
      { path: 'account-link-approval', component: AccountLinkApprovalComponent },
      { path: "dashboard", component: DashboardComponent, canActivate: [ AuthGuard ] },
      { path: 'profile', component: UserInfoComponent, canActivate: [ AuthGuard ] },
      { path: 'app-info', component: AppInfoComponent, canActivate: [ AuthGuard ] },      
      { path: 'atp/management', component: AtpComponent, canActivate: [ AuthGuard ] },
      { path: 'atp/applications', component: AtpApplicationListComponent, canActivate: [ AuthGuard ] },
      { path: 'firm-edit', component: FirmEditComponent, canActivate: [ AuthGuard, FirmFeatureGuard ] },
      { path: 'individual-edit', component: IndividualEditComponent, canActivate: [ AuthGuard, IndividualFeatureGuard ] },
      {
        path: 'firms',
        canMatch: [ FirmFeatureGuard ],
        children: [
          { path: '', redirectTo: 'management', pathMatch: 'full' },
          { path: 'management', component: FirmManagementComponent, canActivate: [ AuthGuard, FirmFeatureGuard ] },
          { path: 'applications', component: FirmApplicationListComponent, canActivate: [ AuthGuard, FirmFeatureGuard ] },
        ],
      },
      {
        path: 'individuals',
        canMatch: [ IndividualFeatureGuard ],
        children: [
          { path: '', redirectTo: 'management', pathMatch: 'full' },
          { path: 'management', component: IndividualListComponent, canActivate: [ AuthGuard, IndividualFeatureGuard ] },
          { path: 'applications', component: IndividualApplicationListComponent, canActivate: [ AuthGuard, IndividualFeatureGuard ] },
        ],
      },
      { path: 'payments', component: PaymentsComponent, canActivate: [ AuthGuard ] },
      { path: 'complaints', component: ComplaintsComponent},
      { path: 'login-failed', component: LoginFailedComponent},      
      {
        path: 'sessions',
        loadChildren: () => import('./components/sessions/sessions.module').then(m => m.SessionsModule),
      },

      { path: 'payments',
        canActivate: [ AuthGuard ],
        //component: PaymentsComponent,
        loadChildren: () => import('./components/payments/payment.module').then(m => m.PaymentsModule)
      },

      { path: 'pay-online/:id',
        canActivate: [ AuthGuard ],
        component: PayOnlineComponent
      },
      { path: 'payment/cancel',
        canActivate: [ AuthGuard ],
        component: PayOnlineCancelComponent
      },
      { path: 'payment/failure',
        canActivate: [ AuthGuard ],
        component: PayOnlineFailureComponent
      },
      { path: 'payment/duplicate',
        canActivate: [ AuthGuard ],
        component: PayOnlineDuplicateComponent
      },
      { path: 'payment/success',
        canActivate: [ AuthGuard ],
        component: PayOnlineSuccessComponent
      },
    ],
  },
  { path: '**', redirectTo: 'home' },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      initialNavigation: !isIframe ? "enabledNonBlocking" : "disabled",
      relativeLinkResolution: 'legacy'
    }),
  ],
  exports: [RouterModule],
  declarations: [
    LoginFailedComponent
  ],
})
export class RoutesRoutingModule { }
